import PropTypes from "prop-types";

export default function LabelCustom({ children, className = "", other }) {
  return (
    <label
      className={` ${className}`}
      {...other}
      style={{
        fontSize: "16px",
        fontWeight: 500,
        color: " var(--color-on-base-content-high)",
        paddingBottom: "4px",
      }}
    >
      {children}
    </label>
  );
}

LabelCustom.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  other: PropTypes.any,
};
